<template>
    <!-- 对话框 -->
    <el-dialog title="添加三方账户" :visible.sync="show" :before-close="closeDialog" style="width: 1000px; margin: 0 auto">
        <!-- 基本信息表单 -->
        <div class="form-box third">
            <el-form label-width="80px">
                
                <el-form-item label="三方名称" label-width="130px">
                    <el-select
                            v-model="submit_data.third_id"
                            placeholder="请选择三方"
                            @visible-change="sfVisibleChange"
                          
                            clearable
                        >
                            <el-option
                                v-for="item in third"
                                :key="item.third_id"
                                :label="item.third_name"
                                :value="item.third_id"
                            >
                            </el-option>
                        </el-select>
                </el-form-item>

                <el-form-item label="关联电话" label-width="130px">
                    <el-input v-model="submit_data.consumer_phone" placeholder="请输入关联电话" maxlength="11">
                    </el-input>
                </el-form-item>

               
            </el-form>

            <div style="display: flex; justify-content: flex-end; margin-top: 20px">
                <el-button type="primary" @click="addThirdAccountSubmit">保存</el-button>
                <el-button @click="closeDialog">关闭</el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
var _this;

export default {
    props: {
        isShow: Boolean
    },
    watch: {
        isShow(newData, oldData) {
            _this.show = true;
        }
    },
    data() {
        return { 
            show: false,
            third: '',
            // 表单提交数据
            submit_data: {
                third_id: '',
                consumer_phone: ''
            },

            submit_rules: {
                third_id: {
                    placeholder: '三方名称',
                    rules: {
                        required: true,
                        message: '三方名称错误',
                        regulation: 'gt_str',
                            rulesData: '0|1'
                    }
                }
              
            }
        };
    },
    created() {
        _this = this;
    },
    methods: {
        
       sfVisibleChange(val) {
            if(val) {
                _this
                .$post('/Cooperatewine/thirdAccountList')
                .then((res) => {
                    _this.third = res.data;
                })
                .catch((err) => {});
            }
        },
    
      
        // 关闭方法
        closeDialog() {
            _this.show = false;
      

            _this.submit_data = {
                third_id: '',
                consumer_phone: ''
            };
        },

        // 提交按钮
   
        addThirdAccountSubmit() {
            _this
                .$post('/Cooperatewine/addThirdAccountSubmit', _this.submit_data, _this.submit_rules)
                .then((res) => {
                    _this.$message.success(res.msg);

                    _this.closeDialog();

                    _this.$emit('onSubmit');
                })
                .catch((err) => {});
        }
    }
};
</script>

<style scoped>
.form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
}
</style>
<style>
.third .el-input--small .el-input__inner {
    width: 210px;
}
    
</style>